import { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Accordion } from "react-bootstrap";
import {
  FaUserCircle,
  FaCalendarAlt,
  FaFileExport,
  FaDownload,
} from "react-icons/fa";
import axios from "axios";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { BASE_URL, getStatusDotColor, HEADERS } from "../../utils/constant";
import AttendanceModal from "../../components/Modals/AttendanceModal";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import { useCommonContext } from "../../utils/context";
import ExportModal from "../../components/Modals/ExportsModel/main";
import StatusBadge from "../../components/StatusBadge";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import AddDeviceModal from "../../components/Modals/AddDeviceModal";
import FetchLogsModal from "../../components/Modals/FetchLogsModal";

function Attendance() {
  const [showModal, setShowModal] = useState(false);
  const userRole = localStorage.getItem("role");
  const [modalTechnician, setModalTechnician] = useState(null);
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTechId, setLoadingTechId] = useState(null);
  const [page, setPage] = useState(1);
  const { fetchAllusers } = useCommonContext;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const totalPages = Math.ceil(totalUsers / itemsPerPage);
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [showFetchLogsModal, setShowFetchLogsModal] = useState(false);

  const [data, setData] = useState({
    present: 0,
    absent: 0,
    idle: 0,
    onleave: 0,
  });
  const [showExportModal, setShowExportModal] = useState(false);
  const userPermissions = localStorage.getItem("user_permissions");

  useEffect(() => {
    fetchTechnicians();
    fetchStatusCounts();
  }, [selectedStatus, searchText, page, itemsPerPage]);

  useEffect(() => {
    setPage(1);
  }, [selectedStatus, searchText]);

  const fetchTechnicians = async () => {
    setLoading(true);
    try {
      const roles = ["technician", "agent", "superuser", "sales"];
      const rolesQueryString = roles.map((role) => `role=${role}`).join("&");
      const url = `${BASE_URL}/users/tms_users/?${rolesQueryString}`;
      const params = {
        page: page,
        status: selectedStatus || "",
        search: searchText || "",
        page_size: itemsPerPage,
      };
      const response = await axios.get(url, {
        headers: HEADERS,
        params: params,
      });
      if (response.data && response.data.results) {
        setTechnicians(response.data.results);

        setTotalUsers(response.data.count);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusCounts = async () => {
    setLoading(true);
    try {
      const url = `${BASE_URL}/users/tms_users/attendance_counts/`;

      const response = await axios.get(url, {
        headers: HEADERS,
      });
      if (response.data) {
        setData(response.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (selectedItem) => {
    setPage(selectedItem.selected + 1);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setPage(1);
  };

  const handleModalShow = async (tech) => {
    try {
      setLoadingTechId(tech.id);

      const response = await axios.get(
        `${BASE_URL}/users/attendance/?user_id=${tech.id}`,
        { headers: HEADERS },
      );

      setModalTechnician({
        ...tech,
        today_attendance: response.data.results,
      });

      setShowModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingTechId(null);
    }
  };

  const handleExportAll = () => {
    setShowExportModal(true);
  };

  return (
    <div className="container-fluid  ">
      <div className="mt-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Today's Attendance</h4>
        <div className="d-none d-md-flex align-items-center gap-2 flex-nowrap">
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="uniform-input search-text"
            style={{ width: "220px" }}
          />

          <Form.Select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="uniform-input"
            style={{ width: "160px" }}
          >
            <option value="">All Status</option>
            <option value="present">Present</option>
            <option value="absent">Absent</option>
            <option value="idle">Idle</option>
            <option value="onleave">On-leave</option>
          </Form.Select>

          {userPermissions.includes("attendance_export_all_attendance") && (
            <CommonButton className="uniform-button" onClick={handleExportAll}>
              <FaFileExport className="me-1" /> Export
            </CommonButton>
          )}

          {userRole === "admin" && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowAddDeviceModal(true)}
            >
              Manage Device
            </CommonButton>
          )}

          <CommonButton
            className="uniform-button"
            onClick={() => setShowFetchLogsModal(true)}
          >
            <FaDownload className="me-1" /> Fetch Logs
          </CommonButton>
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="d-flex flex-column gap-3">
                  <Form.Group controlId="attendanceSearch">
                    <Form.Control
                      type="text"
                      placeholder="Search here..."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      className="uniform-input search-text"
                      style={{
                        fontSize: "14px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                      }}
                    />
                  </Form.Group>
                  <Form.Group controlId="statusFilter">
                    <Form.Select
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      className="uniform-input"
                      style={{
                        fontSize: "14px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                      }}
                    >
                      <option value="">All Status</option>
                      <option value="present">Present</option>
                      <option value="absent">Absent</option>
                      <option value="idle">Idle</option>
                      <option value="onleave">On-leave</option>
                    </Form.Select>
                  </Form.Group>
                  {userPermissions.includes(
                    "attendance_export_all_attendance",
                  ) && (
                    <CommonButton
                      className="uniform-button w-100 d-flex align-items-center justify-content-center"
                      onClick={handleExportAll}
                    >
                      <FaFileExport className="me-2" /> Export Data
                    </CommonButton>
                  )}
                  {userRole === "admin" && (
                    <CommonButton
                      className="uniform-button w-100 d-flex align-items-center justify-content-center"
                      onClick={() => setShowAddDeviceModal(true)}
                    >
                      Manage Device
                    </CommonButton>
                  )}
                  <CommonButton
                    className="uniform-button w-100 d-flex align-items-center justify-content-center"
                    onClick={() => setShowFetchLogsModal(true)}
                  >
                    <FaDownload className="me-2" /> Fetch Logs
                  </CommonButton>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      <Row className="g-4 d-flex cards">
        {[
          {
            label: "Total Employees",
            value: data.total_users,
            color: "#4A90E2",
            icon: "bi bi-people-fill",
          },
          {
            label: "Present",
            value: data.total_present,
            color: "#6FCF97",
            icon: "bi bi-person-check-fill",
          },
          {
            label: "Absent",
            value: data.total_absent,
            color: "#EB5757",
            icon: "bi bi-person-x-fill",
          },
          {
            label: "Idle",
            value: data.total_idle,
            color: "#F2C94C",
            icon: "bi bi-hourglass-top",
          },
          {
            label: "On Leave",
            value: data.total_onleave,
            color: "#9B51E0",
            icon: "bi bi-calendar-event-fill",
          },
        ].map((item, index) => (
          <Col key={index} className="d-flex">
            <Card
              className="rounded-3 shadow-sm w-100"
              style={{
                borderColor: "#E5E7EB",
                backgroundColor: "#fff",
                textAlign: "left",
                minWidth: "200px",
              }}
            >
              <Card.Body className="p-3">
                <div className="d-flex justify-content-between align-items-center">
                  <span style={{ fontSize: "0.9rem", fontWeight: "800" }}>
                    {item.label}
                  </span>
                  <i
                    className={item.icon}
                    style={{ fontSize: "1.6rem", color: item.color }}
                  ></i>
                </div>
                <p
                  className="fw-bold mb-0 mt-1"
                  style={{
                    color: item.color,
                    fontSize: "1.8rem",
                    textAlign: "left",
                  }}
                >
                  {item.value}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ overflowY: "scroll", maxHeight: "560px" }}>
        {loading ? (
          <Loader />
        ) : technicians.length > 0 ? (
          <>
            <table className="table  tstart">
              <thead className="thead">
                <tr style={{ whiteSpace: "nowrap" }}>
                  <th style={{ width: "250px" }}>Name</th>
                  <th style={{ width: "250px" }}>Role</th>
                  <th style={{ width: "250px" }}>Status</th>
                  <th style={{ width: "250px" }}>Punch Type</th>
                  <th style={{ width: "250px" }}>Punch In / Out</th>
                  <th style={{ width: "250px" }} className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {technicians.map((tech) => (
                  <tr key={tech.id} className="tbody">
                    <td className="d-flex align-items-center">
                      <div className="me-2 position-relative">
                        {tech.profile_image ? (
                          <img
                            src={tech.profile_image}
                            alt="Profile"
                            className="rounded-circle"
                            style={{
                              width: "30px",
                              height: "30px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FaUserCircle size={30} className="text-secondary" />
                        )}
                        <span
                          className="position-absolute attendence-dot"
                          style={{
                            backgroundColor: getStatusDotColor(
                              tech.today_attendance?.status || "",
                            ),
                          }}
                        ></span>
                      </div>
                      <span>
                        {tech.first_name} {tech.last_name}
                      </span>
                    </td>
                    <td>
                      {tech.role === "agent"
                        ? "Executive"
                        : tech.role === "technician"
                          ? "Technician"
                          : tech.role === "superuser"
                            ? "Manager"
                            : tech.role}
                    </td>
                    <td>
                      <StatusBadge
                        status={tech.today_attendance?.status || "—"}
                      />
                    </td>
                    <td>{tech.attendence_type}</td>
                    <td>
                      {tech.today_attendance?.punch_in &&
                        new Date(
                          tech.today_attendance.punch_in,
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: false,
                        })}{" "}
                      <span className="text-muted">-</span>{" "}
                      {tech.today_attendance?.punch_out &&
                        new Date(
                          tech.today_attendance.punch_out,
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: false,
                        })}
                    </td>

                    <td className="text-center">
                      <Button
                        variant="link"
                        size="sm"
                        onClick={() => handleModalShow(tech)}
                        disabled={loadingTechId === tech.id}
                        style={{
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                        }}
                      >
                        {loadingTechId === tech.id ? (
                          <span className="mini-loader text-primary"></span>
                        ) : (
                          <FaCalendarAlt size={16} className="text-primary" />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <NoData message="No Data Found" height="400px" />
        )}
      </div>

      {technicians.length > 0 && (
        <Pagination
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalTechnician && (
        <AttendanceModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          technician={modalTechnician}
          fetchTechnicians={fetchTechnicians}
          fetchStatusCounts={fetchStatusCounts}
        />
      )}

      {showExportModal && (
        <ExportModal
          show={showExportModal}
          handleClose={() => setShowExportModal(false)}
          title="allAttendence"
        />
      )}
      <AddDeviceModal
        show={showAddDeviceModal}
        handleClose={() => setShowAddDeviceModal(false)}
      />

      <FetchLogsModal
        show={showFetchLogsModal}
        handleClose={() => setShowFetchLogsModal(false)}
        onSuccess={fetchTechnicians}
      />
    </div>
  );
}

export default Attendance;
